import MenuItem from "@mui/material/MenuItem";
import { computeShellUID } from "../../../../../../../utils/pvUID";
import Box from "@mui/material/Box";

const shellMultiLineHeaderStyle = {
  width: "100%",
  minWidth: 0,

  textAlign: "center",

  margin: 0,
  padding: 0,

  lineHeight: 1.1,
};

export const SHELL_COMPONENTS = [
  "2:1 S.E Head (L/B)",
  "Flat Round Head (L/B)",
  "Flat Round Head (R/T)",
  "Flat Rectangular Head (L/B)",
  "Flat Rectangular Head (R/T)",
  "Cylindrical Shell",
  "Conical Shell",
  "2:1 S.E Head (R/T)",
  "Torispherical Head",
  "Spherical Head",
];

export const getColumns = (getValues, isDark) => [
  {
    accessorKey: "UID",
    header: "UID",
    size: 100,
    enableEditing: false,
    enableSorting: false,
    muiTableHeadCellProps: {
      align: "center",
    },
    muiTableBodyCellProps: {
      sx: {
        textAlign: "center",
        cursor: "default",
        padding: 0,
      },
    },
    Cell: ({ row }) => {
      const projectTag = getValues("tagNo");
      const computed = computeShellUID(row.original.Component, projectTag);
      return (
        <Box
          sx={{
            width: "100%",
            minWidth: 0,
            height: "100%",

            display: "flex",
            alignItems: "center",
            justifyContent: "center",

            p: 0,

            textAlign: "center",
            cursor: "default",

            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {row.original.UID || computed || ""}
        </Box>
      );
    },
  },
  {
    accessorKey: "Component",
    header: "Component",
    size: 150,
    muiTableHeadCellProps: {
      align: "center",
    },
    muiEditTextFieldProps: () => ({
      children: SHELL_COMPONENTS.map((Component) => (
        <MenuItem key={Component} value={Component}>
          {Component}
        </MenuItem>
      )),
      select: true,
      sx: {
        "& .MuiSelect-select": {
          textAlign: "center",
          backgroundColor: "transparent !important",
        },
        "&&": { backgroundColor: "transparent !important" },
      },
    }),
  },
  {
    accessorKey: "Diameter",
    header: "Diameter mm",
    Header: (
      <div style={shellMultiLineHeaderStyle}>
        <div>Diameter</div>
        <div>(mm)</div>
      </div>
    ),
    size: 20,
    enableSorting: false,
    muiTableHeadCellProps: { align: "center" },
  },

  {
    accessorKey: "Material",
    header: "Material",
    size: 70,
    muiTableHeadCellProps: {
      align: "center",
    },
    muiEditTextFieldProps: () => ({
      disabled: true,
      sx: {
        "&&": { backgroundColor: "transparent !important" },
        "& .MuiInputBase-input": {
          padding: "8.5px 8px",
          textAlign: "center",
          color: isDark ? "#e8edf4" : "rgba(0,0,0,0.87)",
          WebkitTextFillColor: isDark ? "#e8edf4" : "rgba(0,0,0,0.87)",
        },
        "& .MuiInputBase-root.Mui-disabled": {
          "& .MuiInputBase-input": {
            color: isDark ? "#e8edf4" : "rgba(0,0,0,0.87)",
            WebkitTextFillColor: isDark ? "#e8edf4" : "rgba(0,0,0,0.87)",
          },
        },
      },
    }),
  },
  {
    accessorKey: "Can Length",
    header: "Can Length",
    Header: (
      <div style={shellMultiLineHeaderStyle}>
        <div>Can Length</div>
        <div>(mm)</div>
      </div>
    ),
    size: 15,
    enableSorting: false,
    muiTableHeadCellProps: {
      align: "center",
    },
  },
  {
    accessorKey: "Long Seam",
    header: "Long Seam",
    Header: (
      <div style={shellMultiLineHeaderStyle}>
        <div>Long Seam</div>
        <div>(deg)</div>
      </div>
    ),
    size: 25,
    enableSorting: false,
    muiTableHeadCellProps: {
      align: "center",
    },
  },
  {
    accessorKey: "Provided Thk",
    header: "Provided Thk",
    Header: (
      <div style={shellMultiLineHeaderStyle}>
        <div>Provided Thk</div>
        <div>(mm)</div>
      </div>
    ),
    size: 35,
    enableSorting: false,
    muiTableHeadCellProps: {
      align: "center",
    },
  },
  {
    accessorKey: "Weight",
    header: "Weight",
    Header: (
      <div style={shellMultiLineHeaderStyle}>
        <div>Weight</div>
        <div>(Kg)</div>
      </div>
    ),
    size: 20,
    enableSorting: false,
    muiTableHeadCellProps: {
      align: "center",
    },
  },
];

export const resultColumns = [
  //column definitions...
  {
    accessorKey: "Allowable_Stress",
    header: "Allowable Stress ",
    Header: (
      <div
        style={{
          width: "100%",
          textAlign: "center",
        }}
      >
        <div style={shellMultiLineHeaderStyle}>Allowable Stress</div>
        <div>
          (N/mm<sup>2</sup>)
        </div>
      </div>
    ),
    size: "50px",
    enableSorting: false,
    muiTableHeadCellProps: {
      align: "center",
    },
  },
  {
    accessorKey: "Required_Thickness",
    header: "Required Thickness (mm)",
    Header: (
      <div
        style={{
          width: "100%",
          textAlign: "center",
        }}
      >
        <div style={shellMultiLineHeaderStyle}>Reqd. Thk</div>
        <div>(mm)</div>
      </div>
    ),
    size: "60px",
    enableSorting: false,
    muiTableHeadCellProps: {
      align: "center",
    },
  },
  {
    accessorKey: "UCS_Curve",
    header: "UCS Curve",
    size: "40px",
    enableSorting: false,
    muiTableHeadCellProps: {
      align: "center",
    },
  },
  {
    accessorKey: "MDMT",
    header: "MDMT (DegC)",
    Header: (
      <div style={shellMultiLineHeaderStyle}>
        <div>MDMT</div>
        <div>(DegC)</div>
      </div>
    ),
    size: "50px",
    enableSorting: false,
    muiTableHeadCellProps: {
      align: "center",
    },
  },
  {
    accessorKey: "MAWP",
    header: "MAWP (N/mm^2)",
    Header: (
      <div style={shellMultiLineHeaderStyle}>
        <div>MAWP</div>
        <div>
          (N/mm<sup>2</sup>)
        </div>
      </div>
    ),
    size: "50px",
    enableSorting: false,
    muiTableHeadCellProps: {
      align: "center",
    },
  },
  {
    accessorKey: "Hydrotest_Pressure",
    header: "Hydrotest Pr.",
    size: "50px",
    enableSorting: false,
    muiTableHeadCellProps: {
      align: "center",
    },
  },
];

export const estimationColumns = [
  //column definitions...
  {
    accessorKey: "Circ_Weld_Hours",
    Header: (
      <div style={shellMultiLineHeaderStyle}>
        <div>Circ Weld</div>
        <div>Hours</div>
      </div>
    ),
    size: "50px",
    enableEditing: false,
  },
  {
    accessorKey: "Long_Weld_Hours",
    Header: (
      <div style={shellMultiLineHeaderStyle}>
        <div>Long Weld</div>
        <div>Hours</div>
      </div>
    ),
    size: "40px",
    enableEditing: false,
  },
  {
    accessorKey: "Rolling_Hours",
    Header: (
      <div style={shellMultiLineHeaderStyle}>
        <div>Rolling</div>
        <div>Hours</div>
      </div>
    ),
    size: "50px",
    enableEditing: false,
  },
  {
    accessorKey: "Dishing_Hours",
    Header: (
      <div style={shellMultiLineHeaderStyle}>
        <div>Dishing</div>
        <div>Hours</div>
      </div>
    ),
    size: "50px",
    enableEditing: false,
  },
  {
    accessorKey: "NDT_Cost",
    Header: (
      <div style={shellMultiLineHeaderStyle}>
        <div>NDT Cost</div>
        <div>($)</div>
      </div>
    ),
    size: "50px",
    type: "number",
  },
];
